import { Calendar } from "lucide-react";

const MESES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export function monthKeyToLabel(key) {
  if (!key || typeof key !== "string") return "";
  const [y, m] = key.split("-");
  const idx = parseInt(m, 10) - 1;
  if (idx < 0 || idx > 11) return key;
  return `${MESES[idx]} ${y}`;
}

export function currentMonthKey() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${m}`;
}

/** Generate list of {value, label} covering the past `pastMonths` months + `futureMonths`. */
export function generateMonthOptions(pastMonths = 12, futureMonths = 1) {
  const out = [];
  const now = new Date();
  for (let i = futureMonths; i >= -pastMonths; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const key = `${d.getFullYear()}-${m}`;
    out.push({ value: key, label: monthKeyToLabel(key) });
  }
  return out;
}

/** Native <select> based month selector — reliable, keyboard-accessible. */
export default function MonthSelector({
  value,
  onChange,
  testid,
  className = "",
  disabled = false,
}) {
  const options = generateMonthOptions(18, 1);
  return (
    <div className={`relative ${className}`}>
      <Calendar className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
      <select
        value={value || currentMonthKey()}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        disabled={disabled}
        className="w-full pl-10 pr-8 py-2.5 bg-white border border-slate-300 focus:border-[#D95A40] focus:ring-2 focus:ring-[#D95A40]/20 focus:outline-none text-sm transition-colors appearance-none disabled:opacity-60"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
